export const supportedLanguages = [
  'en',
  'en-gb',
  'en-sg',
  'da-da',
  'de-de',
  'es-es',
  'es-mx',
  'fi-fi',
  'fr-ca',
  'fr-fr',
  'it-it',
  'nl-nl',
  'no-no',
  'pl-pl',
  'sv-se',
  'es-ar',
  'pt-br',
];
